/**
 * Do not edit directly
 * Generated on Tue, 24 Jan 2023 12:01:59 GMT
 */

export const fontFamilyHeader = "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const fontFamilyText = "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const fontFamilyCode = "'Roboto Mono', monospace";
export const fontFamilySystem = "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const fontFamilyMono = "'Roboto Mono', monospace";
export const fontLetterSpacingH1 = "0.3px";
export const fontLetterSpacingH2 = "0.3px";
export const fontLetterSpacingH3 = "0.3px";
export const fontLetterSpacingH4 = "0.2px";
export const fontLetterSpacingH5 = "0.2px";
export const fontLetterSpacingH6 = "0.2px";
export const fontLetterSpacingSubtitle1 = "0.2px";
export const fontLetterSpacingSubtitle2 = "0.2px";
export const fontLetterSpacingSubtitle3 = "0.2px";
export const fontLetterSpacingBody1 = "0.2px";
export const fontLetterSpacingBody2 = "0.2px";
export const fontLetterSpacingBody3 = "0.2px";
export const fontLetterSpacingCaption = "0.2px";
export const fontLetterSpacingOverline = "1.2px";
export const fontLetterSpacingProductName = "0px";
export const fontLineHeightH1 = "66px";
export const fontLineHeightH2 = "56px";
export const fontLineHeightH3 = "44px";
export const fontLineHeightH4 = "32px";
export const fontLineHeightH5 = "28px";
export const fontLineHeightH6 = "22px";
export const fontLineHeightSubtitle1 = "24px";
export const fontLineHeightSubtitle2 = "22px";
export const fontLineHeightSubtitle3 = "20px";
export const fontLineHeightBody1 = "24px";
export const fontLineHeightBody2 = "22px";
export const fontLineHeightBody3 = "18px";
export const fontLineHeightCaption = "16px";
export const fontLineHeightOverline = "16px";
export const fontLineHeightProductName = "28px";
export const fontSizeH1 = "54px";
export const fontSizeH2 = "44px";
export const fontSizeH3 = "34px";
export const fontSizeH4 = "26px";
export const fontSizeH5 = "20px";
export const fontSizeH6 = "17px";
export const fontSizeSubtitle1 = "19px";
export const fontSizeSubtitle2 = "17px";
export const fontSizeSubtitle3 = "15px";
export const fontSizeBody1 = "19px";
export const fontSizeBody2 = "17px";
export const fontSizeBody3 = "15px";
export const fontSizeCaption = "13px";
export const fontSizeOverline = "10px";
export const fontSizeProductName = "25px";
export const fontWeightMedium = 500;
export const fontWeightRegular = 400;
export const fontWeightBold = 700;
export const fontWeightH1 = 500;
export const fontWeightH2 = 500;
export const fontWeightH3 = 400;
export const fontWeightH4 = 500;
export const fontWeightH5 = 700;
export const fontWeightH6 = 700;
export const fontWeightSubtitle1 = 500;
export const fontWeightSubtitle2 = 500;
export const fontWeightSubtitle3 = 500;
export const fontWeightBody1 = 400;
export const fontWeightBody2 = 400;
export const fontWeightBody3 = 400;
export const fontWeightCaption = 400;
export const fontWeightOverline = 700;
export const fontWeightProductName = 500;
export const h1 = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "54px",
    "fontWeight": 500,
    "lineHeight": "66px",
    "letterSpacing": "0.3px"
};
export const h2 = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "44px",
    "fontWeight": 500,
    "lineHeight": "56px",
    "letterSpacing": "0.3px"
};
export const h3 = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "34px",
    "fontWeight": 400,
    "lineHeight": "44px",
    "letterSpacing": "0.3px"
};
export const h4 = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "26px",
    "fontWeight": 500,
    "lineHeight": "32px",
    "letterSpacing": "0.2px"
};
export const h5 = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "20px",
    "fontWeight": 700,
    "lineHeight": "28px",
    "letterSpacing": "0.2px"
};
export const h6 = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "17px",
    "fontWeight": 700,
    "lineHeight": "22px",
    "letterSpacing": "0.2px"
};
export const subtitle1 = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "19px",
    "fontWeight": 500,
    "lineHeight": "24px",
    "letterSpacing": "0.2px"
};
export const subtitle2 = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "17px",
    "fontWeight": 500,
    "lineHeight": "22px",
    "letterSpacing": "0.2px"
};
export const subtitle3 = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "15px",
    "fontWeight": 500,
    "lineHeight": "20px",
    "letterSpacing": "0.2px"
};
export const body1 = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "19px",
    "fontWeight": 400,
    "lineHeight": "24px",
    "letterSpacing": "0.2px"
};
export const body2 = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "17px",
    "fontWeight": 400,
    "lineHeight": "22px",
    "letterSpacing": "0.2px"
};
export const body3 = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "15px",
    "fontWeight": 400,
    "lineHeight": "18px",
    "letterSpacing": "0.2px"
};
export const caption = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "13px",
    "fontWeight": 400,
    "lineHeight": "16px",
    "letterSpacing": "0.2px"
};
export const overline = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "10px",
    "fontWeight": 700,
    "lineHeight": "16px",
    "letterSpacing": "1.2px"
};
export const productName = {
    "fontFamily": "'Beeline Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    "fontSize": "25px",
    "fontWeight": 500,
    "lineHeight": "28px",
    "letterSpacing": "0px"
};